(() => {
  const BANK_HOLIDAYS = new Set([
    '2026-01-01','2026-04-03','2026-04-06','2026-05-04','2026-05-25','2026-08-31','2026-12-25','2026-12-28',
    '2027-01-01','2027-03-26','2027-03-29','2027-05-03','2027-05-31','2027-08-30','2027-12-27','2027-12-28',
    '2028-01-03','2028-04-14','2028-04-17','2028-05-01','2028-05-29','2028-08-28','2028-12-25','2028-12-26'
  ]);
  const DAY_NAMES = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
  const fmt = new Intl.DateTimeFormat('en-GB', {
    timeZone:'Europe/London', year:'numeric', month:'2-digit', day:'2-digit',
    hour:'2-digit', minute:'2-digit', second:'2-digit', hourCycle:'h23'
  });
  const pad = n => String(n).padStart(2,'0');
  const key = d => `${d.getUTCFullYear()}-${pad(d.getUTCMonth()+1)}-${pad(d.getUTCDate())}`;
  const isDispatchDay = d => {
    const day = d.getUTCDay();
    return day >= 1 && day <= 5 && !BANK_HOLIDAYS.has(key(d));
  };
  const nowLondon = () => {
    const p = Object.fromEntries(fmt.formatToParts(new Date()).filter(x => x.type !== 'literal').map(x => [x.type,x.value]));
    return {year:+p.year, month:+p.month, day:+p.day, hour:+p.hour, minute:+p.minute, second:+p.second};
  };
  const nextDispatchName = ({year,month,day}) => {
    const d = new Date(Date.UTC(year, month-1, day));
    do d.setUTCDate(d.getUTCDate()+1); while (!isDispatchDay(d));
    return DAY_NAMES[d.getUTCDay()];
  };
  const message = (desktop = false) => {
    const now = nowLondon();
    const today = new Date(Date.UTC(now.year, now.month-1, now.day));
    if (isDispatchDay(today) && now.hour < 16) {
      const secondsLeft = 16*3600 - (now.hour*3600 + now.minute*60 + now.second);
      const mins = Math.max(1, Math.ceil(secondsLeft/60));
      const h = Math.floor(mins/60);
      const m = mins % 60;
      const remaining = h ? `${h}h ${m}m` : `${m}m`;
      if (desktop) return `<span class="ae-dispatch-desktop-card"><span class="ae-dispatch-card-copy"><strong>Dispatch today</strong></span><span class="ae-dispatch-card-timer"><span>Order within</span><strong>${remaining}</strong></span></span>`;
      return `<span class="ae-dispatch-status">Order within <span class="ae-dispatch-emphasis">${remaining}</span> for dispatch today (in-stock items)</span>`;
    }
    if (desktop) return `<span class="ae-dispatch-desktop-card"><span class="ae-dispatch-card-copy"><strong>Next dispatch: ${nextDispatchName(now)}</strong></span></span>`;
    return `<span class="ae-dispatch-status">Next dispatch: <span class="ae-dispatch-emphasis">${nextDispatchName(now)}</span></span>`;
  };

  const syncQuestion = root => {
      const custom = root.querySelector('[data-ae-ask]');
      if (!custom) return;
      if (['6947575267409', '6947567829073'].includes(root.dataset.productId) && window.matchMedia('(min-width: 990px)').matches) {
        const questionText = root.querySelector('.jdgm-qa-badge__text');
        if (questionText && /^ask a question/i.test(questionText.textContent.trim())) {
          questionText.textContent = questionText.textContent.trim().replace(/^ask a question\s*[⏐|]\s*/i, '');
        }
        custom.hidden = false;
        return;
      }
      const nativeQuestion = [...root.querySelectorAll('.jdgm-widget a,.jdgm-widget button,.jdgm-widget [role="button"],.jdgm-widget .jdgm-qa-badge__text')].find(el => el.textContent.trim().toLowerCase().startsWith('ask a question'));
      custom.hidden = !!nativeQuestion;
      if (custom.parentElement?.classList.contains('custom__liquid')) custom.parentElement.hidden = !!nativeQuestion;
  };
  document.querySelectorAll('.ae-pdp').forEach(root => {
    const row = root.querySelector('.ae-pdp-review-row');
    if (row) new MutationObserver(() => syncQuestion(root)).observe(row, {childList:true, subtree:true, characterData:true});
    syncQuestion(root);
  });
  const update = () => {
    document.querySelectorAll('.ae-pdp').forEach(syncQuestion);
    document.querySelectorAll('[data-ae-dispatch]').forEach(el => {
      const button = el.closest('product-info')?.querySelector('[id^="ProductSubmitButton-"]');
      const target = el.querySelector('[data-ae-dispatch-message]');
      if (!target) return;
      if (button?.disabled) target.textContent = 'This selection is currently unavailable.';
      else if (el.dataset.specialOrder === 'true' || el.closest('product-info')?.querySelector('[id^="Inventory-"]')?.textContent.includes('Available to order')) target.textContent = 'Special order: dispatch once all items are available.';
      else target.innerHTML = message(window.matchMedia('(min-width: 990px)').matches);
    });
    document.querySelectorAll('[data-ae-setup]').forEach(el => {
      const app = el.querySelector('.ae-setup-apps');
      const hasApp = app && app.innerText.trim().length > 5;
      const fallback = el.querySelector('[data-ae-setup-fallback]');
      const bundle = el.querySelector('.ae-setup-bundle');
      if (bundle) bundle.hidden = !hasApp;
      el.hidden = !hasApp && (!fallback || !fallback.querySelector('.ae-setup-card'));
    });
  };
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-ae-ask]');
    if (!link) return;
    const reviews = document.getElementById('judgeme_product_reviews');
    const button = reviews && Array.from(reviews.querySelectorAll('button,a')).find(el => el.textContent.trim().toLowerCase() === 'ask a question');
    if (button) { event.preventDefault(); button.click(); reviews.scrollIntoView({behavior:'smooth',block:'start'}); }
    else if (['8485116051770', '6947557900369', '6947575267409', '6947567829073'].includes(link.closest('.ae-pdp')?.dataset.productId) && reviews) {
      const questionsTab = reviews.querySelector('#jdgm-tab_questions_answers');
      if (!questionsTab) return;
      event.preventDefault();
      const openQuestion = () => {
        const ask = Array.from(reviews.querySelectorAll('button,a')).find(el => el.textContent.trim().toLowerCase() === 'ask a question');
        if (!ask) return false;
        observer.disconnect();
        ask.click();
        return true;
      };
      const observer = new MutationObserver(openQuestion);
      observer.observe(reviews, {childList:true,subtree:true});
      questionsTab.click();
      openQuestion();
      setTimeout(() => observer.disconnect(), 5000);
    }
  });
  const refreshSetup = form => {
    const selected = form.querySelectorAll('[data-ae-setup-check]:checked');
    const button = form.querySelector('.ae-setup-submit');
    if (button && form.dataset.busy !== 'true') {
      button.disabled = selected.length === 0;
      button.textContent = selected.length ? `Add selected (${selected.length})` : 'Add selected';
    }
  };
  document.addEventListener('change', event => {
    const form = event.target.closest('[data-ae-setup-form]');
    if (!form) return;
    if (event.target.matches('[data-ae-setup-variant]')) {
      const card = event.target.closest('.ae-setup-card');
      card.querySelector('[data-ae-setup-check]').value = event.target.value;
      card.querySelector('[data-ae-setup-price]').textContent = event.target.selectedOptions[0].dataset.price;
      const option = event.target.selectedOptions[0];
      const image = card.querySelector('.ae-setup-image img');
      if (image && option.dataset.image) {
        image.removeAttribute('srcset');
        image.src = option.dataset.image;
      }
      if (option.dataset.url) {
        card.querySelectorAll('.ae-setup-image, .ae-setup-name').forEach(link => { link.href = option.dataset.url; });
      }
    }
    refreshSetup(form);
  });
  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-ae-setup-form]');
    if (!form) return;
    event.preventDefault();
    if (form.dataset.busy === 'true') return;
    const direct = event.submitter?.matches('[data-ae-setup-add]') ? event.submitter : null;
    const selected = direct ? [direct.closest('.ae-setup-card').querySelector('[data-ae-setup-check]')] : [...form.querySelectorAll('[data-ae-setup-check]:checked')];
    if (!selected.length) return;
    const status = form.querySelector('[data-ae-setup-status]');
    const button = direct || form.querySelector('.ae-setup-submit');
    const controls = [...form.querySelectorAll('input,select,button[data-ae-setup-add]')];
    form.dataset.busy = 'true';
    button.disabled = true;
    button.textContent = 'Adding…';
    controls.forEach(control => control.disabled = true);
    status.textContent = '';
    const cart = document.querySelector('mini-cart');
    const payload = {items:selected.map(input => ({id:Number(input.value),quantity:1}))};
    try {
      if (cart?.getSectionsToRender) {
        payload.sections = cart.getSectionsToRender().map(section => section.id);
        payload.sections_url = window.location.pathname;
        cart.setActiveElement?.(button);
      }
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method:'POST', headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'}, body:JSON.stringify(payload)
      });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || 'These extras could not be added. Please check your basket before trying again.');
      selected.forEach(input => input.checked = false);
      status.textContent = direct ? 'Item added to your basket.' : 'Selected extras added.';
      const basketLink = document.createElement('a');
      basketLink.href = `${window.Shopify?.routes?.root || '/'}cart`;
      basketLink.textContent = ' View basket';
      status.append(basketLink);
      try {
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate,{source:'aquarium-setup',cart:result});
        if (cart?.renderContents && result.sections) {
          cart.classList.remove('is-empty');
          cart.renderContents(result);
        }
      } catch (_) {
        // The confirmed basket link remains available if an app drawer cannot refresh.
      }
    } catch (error) {
      status.textContent = 'The extras could not be confirmed. Please check your basket before trying again.';
    } finally {
      form.dataset.busy = 'false';
      controls.forEach(control => control.disabled = false);
      if (direct) direct.textContent = '+ Add';
      refreshSetup(form);
    }
  });

  window.matchMedia('(min-width: 990px)').addEventListener('change', update);
  update();
  const timer = window.setInterval(update, 1500);
  window.addEventListener('pagehide', () => window.clearInterval(timer), {once:true});
})();
(() => {
  const labels = {
    'neutro-plant-fertiliser': 'Neutro+ plant fertiliser',
    'neutro-t-aquarium-plant-fertiliser': 'Neutro T plant fertiliser',
    'neutro-co2-liquid-carbon': 'Neutro CO₂ liquid carbon',
    'neutro-terratabs-15-pieces': 'Neutro TerraTabs root tabs',
    'copy-of-superfish-aquarium-plant-tweezers': 'Superfish plant tweezers',
    'superfish-aquarium-plant-scissors': 'Superfish plant scissors',
    'superfish-aquarium-plant-scissors-25cm': 'Superfish plant scissors',
    'amano-shrimp': 'Amano shrimp × 5'
  };
  const refresh = () => {
    document.querySelectorAll('.ae-pdp').forEach(root => {
      const info = root.querySelector('.product__info-container');
      const priceBlock = info?.querySelector('[id^="price-"]');
      const inventory = info?.querySelector('.product__inventory');
      if (priceBlock && inventory && !priceBlock.parentElement.classList.contains('ae-pdp-price-stock')) {
        const row = document.createElement('div');
        row.className = 'ae-pdp-price-stock';
        priceBlock.before(row);
        row.append(priceBlock, inventory);
      }
      const title = root.querySelector('h1');
      const section = root.querySelector(':scope > .page-width');
      if (title && section && !root.querySelector('.ae-pdp-breadcrumb')) {
        const nav = document.createElement('nav');
        nav.className = 'ae-pdp-breadcrumb';
        nav.setAttribute('aria-label', 'Breadcrumb');
        const home = document.createElement('a');
        home.href = window.Shopify?.routes?.root || '/';
        home.textContent = 'Home';
        const current = document.createElement('span');
        current.setAttribute('aria-current', 'page');
        current.textContent = title.textContent.trim();
        nav.append(home, document.createTextNode(' › '));
        if (window.matchMedia('(min-width: 990px)').matches) {
          try {
            const data = JSON.parse(root.querySelector('[data-ae-breadcrumb-collections]')?.textContent || '{}');
            const collections = data.collections || [];
            const pathHandle = location.pathname.match(/\/collections\/([^/]+)\/products\//)?.[1];
            const referrer = document.referrer ? new URL(document.referrer) : null;
            const referrerHandle = referrer?.origin === location.origin ? referrer.pathname.match(/\/collections\/([^/]+)(?:\/|$)/)?.[1] : null;
            const storageKey = 'ae-pdp-collection-' + root.dataset.productId;
            let remembered = null;
            try {
              const navigation = performance.getEntriesByType('navigation')[0]?.type;
              if (navigation === 'reload' || navigation === 'back_forward') remembered = sessionStorage.getItem(storageKey);
            } catch (_) {}
            const source = [data.current, pathHandle, referrerHandle, remembered].map(handle => collections.find(item => item.handle === handle)).find(Boolean);
            const category = source || (root.dataset.productId === '6947575267409' ? collections.find(item => item.handle === 'floating-aquarium-plants') : root.dataset.productId === '6947567829073' ? collections.find(item => item.handle === 'mixed-boxes-of-plants') : null);
            if (category) {
              const link = document.createElement('a');
              link.href = category.url;
              link.textContent = category.title.split('|')[0].trim();
              nav.append(link, document.createTextNode(' › '));
              try { sessionStorage.setItem(storageKey, category.handle); } catch (_) {}
            }
          } catch (_) {}
        }
        nav.append(current);
        section.prepend(nav);
      }
      const button = root.querySelector('.product__info-container [id^="ProductSubmitButton-"]');
      if (!button) return;
      const label = button.querySelector('span:not(.ae-pdp-button-price)');
      let suffix = button.querySelector('.ae-pdp-button-price');
      const plan = root.querySelector('input[name="selling_plan"]:not([disabled]),select[name="selling_plan"]');
      const price = root.querySelector('.product__info-container .price');
      const amount = price?.querySelector(price.classList.contains('price--on-sale') ? '.price-item--sale' : '.price__regular .price-item');
      const valid = !button.disabled && label?.textContent.trim().toLowerCase() === 'add to cart' && !(plan?.value) && amount;
      if (!valid) { suffix?.remove(); return; }
      if (!suffix) { suffix = document.createElement('span'); suffix.className = 'ae-pdp-button-price'; button.append(suffix); }
      const text = ' · ' + amount.textContent.replace(/\s+/g, '').trim();
      if (suffix.textContent !== text) suffix.textContent = text;
    });
    document.querySelectorAll('.ae-setup-name').forEach(link => {
      const handle = new URL(link.href).pathname.split('/').pop();
      if (!labels[handle]) return;
      if (!link.title) link.title = link.textContent.trim();
      if (link.textContent !== labels[handle]) link.textContent = labels[handle];
    });
  };
  refresh();
  const timer = window.setInterval(refresh, 500);
  window.addEventListener('pagehide', () => window.clearInterval(timer), {once:true});
})();

(() => {
  document.querySelectorAll('.ae-pdp .thumbnail-list').forEach(list => {
    if (list.dataset.aeVerticalControls) return;
    list.dataset.aeVerticalControls = 'true';
    const previous = document.createElement('button');
    const next = document.createElement('button');
    for (const button of [previous, next]) {
      button.type = 'button';
      button.className = 'ae-gallery-step';
      button.setAttribute('aria-controls', list.id);
    }
    previous.setAttribute('aria-label', 'Show previous product thumbnails');
    next.setAttribute('aria-label', 'Show more product thumbnails');
    previous.textContent = '↑';
    next.textContent = '↓';
    list.before(previous);
    list.after(next);
    const updateControls = () => {
      const overflow = list.scrollHeight > list.clientHeight + 2;
      previous.hidden = next.hidden = !overflow;
      previous.disabled = list.scrollTop < 2;
      next.disabled = list.scrollTop + list.clientHeight >= list.scrollHeight - 2;
    };
    const step = direction => {
      const items = [...list.children].filter(item => item.getBoundingClientRect().height > 0);
      if (items.length < 2) return;
      const distance = items[1].offsetTop - items[0].offsetTop;
      const count = Math.max(1, Math.floor((list.clientHeight + 10) / distance));
      const target = Math.round(list.scrollTop / distance) * distance + direction * count * distance;
      list.scrollTo({top: target, behavior: 'auto'});
      updateControls();
    };
    previous.addEventListener('click', () => step(-1));
    next.addEventListener('click', () => step(1));
    list.addEventListener('scroll', updateControls, {passive:true});
    new ResizeObserver(updateControls).observe(list);
    updateControls();
  });
})();

// Anchor the existing desktop badge to the main gallery viewport.
(() => {
  if (!matchMedia('(min-width:990px)').matches) return;
  const root = document.querySelector('.ae-pdp:is([data-product-id="6947632775249"],:is([data-product-id="8319055855930"],:is([data-product-id="6947592831057"],:is([data-product-id="8485116051770"],[data-product-id="6947557900369"],[data-product-id="6947575267409"],[data-product-id="6947567829073"]))))');
  const badge = root?.querySelector('.product__media-wrapper > .aqua-bestseller-badge');
  const imageContainer = root?.querySelector('product-gallery');
  if (!badge || !imageContainer) return;
  badge.classList.add('ae-main-image-badge');
  imageContainer.append(badge);
})();

(() => {
  const desktop = matchMedia('(min-width:990px)');
  document.querySelectorAll('.ae-pdp.ae-pdp--desktop-bridge .ae-pdp-dispatch a[href="/pages/delivery"], .ae-pdp:is([data-product-id="6947632775249"],:is([data-product-id="8319055855930"],:is([data-product-id="6947592831057"],:is([data-product-id="8485116051770"],[data-product-id="6947557900369"],[data-product-id="6947575267409"],[data-product-id="6947567829073"])))) .ae-pdp-dispatch a[href="/pages/delivery"], .ae-pdp:is([data-preview-view="potted-plants"],[data-preview-view="plants-merged"][data-ae-plant-family="potted-plants"]) .ae-pdp-dispatch a[href="/pages/delivery"]').forEach((link, index) => {
    if (!('showPopover' in HTMLElement.prototype)) return;
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'ae-delivery-trigger';
    button.textContent = link.textContent;
    button.setAttribute('aria-haspopup', 'dialog');
    button.setAttribute('aria-expanded', 'false');
    const popup = document.createElement('div');
    popup.id = `ae-delivery-popover-${index}`;
    popup.className = 'ae-delivery-popover';
    popup.setAttribute('popover', 'auto');
    popup.setAttribute('role', 'dialog');
    popup.setAttribute('aria-labelledby', `${popup.id}-title`);
    popup.innerHTML = `<button type="button" class="ae-delivery-popover-close" aria-label="Close delivery details">×</button><h2 id="${popup.id}-title">Delivery details</h2><ul><li><strong>Royal Mail Tracked 24 — from £4.99</strong><br>Estimated 1–3 working days after dispatch.</li><li><strong>DPD Express — from £6.99</strong><br>Estimated 1–2 working days after dispatch. Recommended for live plants where available.</li></ul><p>Order before 4pm Monday–Friday for normal same-working-day dispatch. Special-order items leave once the whole order is available.</p><p>Delivery times are estimates, not guarantees. Exact services and charges depend on your address and are shown at checkout.</p>`;
    if (link.closest('.ae-pdp.ae-pdp--desktop-bridge') || link.closest('.ae-pdp')?.dataset.previewView === 'potted-plants' || (link.closest('.ae-pdp')?.dataset.previewView === 'plants-merged' && link.closest('.ae-pdp')?.dataset.aePlantFamily === 'potted-plants') || ['8319055855930', '6947592831057', '8485116051770', '6947557900369', '6947575267409', '6947567829073'].includes(link.closest('.ae-pdp')?.dataset.productId)) {
      popup.classList.add('ae-delivery-compact');
      popup.innerHTML = `<button type="button" class="ae-delivery-popover-close" aria-label="Close delivery details">×</button><h2 id="${popup.id}-title">Delivery details</h2><div class="ae-delivery-options"><div class="ae-delivery-option"><span class="ae-delivery-carrier">Royal Mail</span><h3>Tracked 24</h3><div class="ae-delivery-cost">From <strong>£4.99</strong></div><span class="ae-delivery-time">1–3 working days</span></div><div class="ae-delivery-option ae-delivery-recommended"><span class="ae-delivery-label">Recommended</span><span class="ae-delivery-carrier">DPD</span><h3>Express</h3><div class="ae-delivery-cost">From <strong>£6.99</strong></div><span class="ae-delivery-time">1–2 working days</span></div></div><p class="ae-delivery-footnote">Estimated times after dispatch.<br>Options and final prices at checkout.</p>`;
    }
    button.setAttribute('popovertarget', popup.id);
    button.setAttribute('aria-controls', popup.id);
    const position = () => {
      if (!popup.matches(':popover-open')) return;
      const rect = button.getBoundingClientRect();
      const box = popup.getBoundingClientRect();
      popup.style.left = `${Math.max(16, Math.min(rect.right - box.width, innerWidth - box.width - 16))}px`;
      popup.style.top = `${Math.max(16, rect.bottom + box.height + 8 <= innerHeight - 16 ? rect.bottom + 8 : rect.top - box.height - 8)}px`;
    };
    popup.addEventListener('toggle', () => {
      const open = popup.matches(':popover-open');
      button.setAttribute('aria-expanded', String(open));
      if (open) position();
    });
    popup.querySelector('button').addEventListener('click', () => { popup.hidePopover(); button.focus(); });
    const sync = () => {
      if (desktop.matches) {
        if (!popup.isConnected) document.body.append(popup);
        if (link.isConnected) link.replaceWith(button);
      } else {
        if (popup.matches(':popover-open')) popup.hidePopover();
        if (button.isConnected) button.replaceWith(link);
        popup.remove();
      }
    };
    desktop.addEventListener('change', sync);
    window.addEventListener('resize', position);
    window.addEventListener('scroll', position, {passive:true});
    sync();
  });
})();

document.addEventListener('click', event => {
  const button = event.target.closest('[data-ae-stock-notify]');
  if (!button || !window.matchMedia('(min-width:990px)').matches) return;
  const trigger = button.closest('.ae-pdp')?.querySelector('.product__info-container .klaviyo-bis-trigger')
    || document.querySelector('#MainContent > .shopify-section:not([id*="__desktop_"]) .klaviyo-bis-trigger');
  trigger?.click();
});

(() => {
  const root = document.querySelector('.ae-pdp:is([data-product-id="8319055855930"],:is([data-product-id="6947592831057"],:is([data-product-id="8485116051770"],[data-product-id="6947557900369"],[data-product-id="6947575267409"],[data-product-id="6947567829073"])))');
  const sticky = root?.querySelector('animate-sticky');
  const panel = root?.querySelector('.product__info-container');
  if (!sticky || !panel) return;
  const desktop = window.matchMedia('(min-width:990px)');
  let queued = false;
  const update = () => {
    queued = false;
    const target = panel.querySelector('.klaviyo-bis-trigger') || panel.querySelector('.product-form__buttons');
    const rect = target?.getBoundingClientRect();
    sticky.classList.toggle('ae-xl-sticky-visible', desktop.matches && !!rect && rect.height > 0 && rect.bottom <= 0);
  };
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(update);
  };
  window.addEventListener('scroll', schedule, {passive:true});
  window.addEventListener('resize', schedule);
  desktop.addEventListener('change', schedule);
  new ResizeObserver(schedule).observe(panel);
  new MutationObserver(schedule).observe(panel, {childList:true,subtree:true});
  update();
})();

